/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shot_Change_Offset_FramesInputs */

const en_shot_change_offset_frames = /** @type {(inputs: Shot_Change_Offset_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shot Change Offset (Frames)`)
};

const fr_shot_change_offset_frames = /** @type {(inputs: Shot_Change_Offset_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Décalage du changement de plan (images)`)
};

const de_shot_change_offset_frames = /** @type {(inputs: Shot_Change_Offset_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Einstellungswechsel-Versatz (Frames)`)
};

const it_shot_change_offset_frames = /** @type {(inputs: Shot_Change_Offset_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Offset del cambio di inquadratura (fotogrammi)`)
};

const ru_shot_change_offset_frames = /** @type {(inputs: Shot_Change_Offset_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Смещение при смене кадра (кадры)`)
};

const es_shot_change_offset_frames = /** @type {(inputs: Shot_Change_Offset_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Desplazamiento del cambio de toma (fotogramas)`)
};

const zh_cn2_shot_change_offset_frames = /** @type {(inputs: Shot_Change_Offset_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`镜头切换偏移量（帧）`)
};

const ja_shot_change_offset_frames = /** @type {(inputs: Shot_Change_Offset_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ショット変更オフセット（フレーム）`)
};

const hi_shot_change_offset_frames = /** @type {(inputs: Shot_Change_Offset_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शॉट परिवर्तन ऑफ़सेट (फ्रेम)`)
};

const pt_pt2_shot_change_offset_frames = /** @type {(inputs: Shot_Change_Offset_FramesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deslocamento de mudança de tomada (quadros)`)
};

/**
* | output |
* | --- |
* | "Shot Change Offset (Frames)" |
*
* @param {Shot_Change_Offset_FramesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shot_change_offset_frames = /** @type {((inputs?: Shot_Change_Offset_FramesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shot_Change_Offset_FramesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_shot_change_offset_frames(inputs)
	if (locale === "de") return de_shot_change_offset_frames(inputs)
	if (locale === "it") return it_shot_change_offset_frames(inputs)
	if (locale === "ru") return ru_shot_change_offset_frames(inputs)
	if (locale === "es") return es_shot_change_offset_frames(inputs)
	if (locale === "zh-CN") return zh_cn2_shot_change_offset_frames(inputs)
	if (locale === "ja") return ja_shot_change_offset_frames(inputs)
	if (locale === "hi") return hi_shot_change_offset_frames(inputs)
	if (locale === "pt-PT") return pt_pt2_shot_change_offset_frames(inputs)
	return en_shot_change_offset_frames(inputs)
});